// extracted by mini-css-extract-plugin
module.exports = {"announcements":"N_fr p-2","announcement":"N_fs card my-2","announcement--highlighted":"N_ft","announcement__list-item":"N_fv py-1","announcement__flag":"N_fw"};